import { Card, CardBody } from "reactstrap";
import WeekTable from "./WeekTable";
import { useUrenoverzichtContext } from "./context/UrenoverzichtContext";

const WeeklyOverview = () => {
	const { hoursData } = useUrenoverzichtContext();

	return (
		<div className="col-12">
			{!Array.isArray(hoursData?.arrWeek) && hoursData && (
				<Card className="main-card">
					<CardBody className="table-responsive">
						<h5 className="mb-4">Weekoverzicht</h5>
						{hoursData?.arrWeek !== undefined &&
							Object.keys(hoursData.arrWeek).map((item) => {
								return (
									<WeekTable
										weekno={item}
										list={hoursData.arrWeek[item]}
										sum={
											hoursData.arrWeekSum[item] !== undefined
												? hoursData.arrWeekSum[item]
												: null
										}
									/>
								);
							})}
					</CardBody>
				</Card>
			)}
		</div>
	);
};

export default WeeklyOverview;
